import React, {useEffect, useState} from "react";
import SuccessImg from '../../../assets/img/success-img.svg';
import {serverRequest} from "../../../util/server_request";
import { useLocation, useNavigate } from 'react-router-dom';
import {notifyUser} from "../../../util/util";
import {Spin} from "antd";
import secureLocalStorage from "react-secure-storage";

export const VerifyEmail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    // Read raw encoded params from location.search so we preserve characters like '+'
    const rawCodeParam = location.search.match(/(?:[?&]code=)([^&]+)/)?.[1];
    const rawEmailParam = location.search.match(/(?:[?&]email=)([^&]+)/)?.[1];
    const code = rawCodeParam ? decodeURIComponent(rawCodeParam) : queryParams.get('code');
    const email = rawEmailParam ? decodeURIComponent(rawEmailParam) : queryParams.get('email');

    const [loading, setLoading] = useState(false)
    const [verified, setVerified] = useState(false)

    const toggleLoading = () => setLoading(prevState => !prevState)

    useEffect(() => {
        secureLocalStorage.setItem('email', email)
        
        // Get employerNumber from storage if available
        const employerNumber = secureLocalStorage.getItem('employerNumber')
        
        const verifyEmailCode = () => {
            if (!code && !email){
                return notifyUser('error', 'Visit your email to confirm!', 'Error')
            }
            toggleLoading()
            // Encode query params to ensure special characters (e.g. '+') are preserved server-side
            // Include employerNumber as URL param if available
            let url = `auth/verify/email/code?code=${encodeURIComponent(code)}&email=${encodeURIComponent(email)}`;
            if (employerNumber) {
                url += `&employerNumber=${encodeURIComponent(employerNumber)}`;
            }
            
            serverRequest('GET', url)
                .then(result => {
                    toggleLoading()
                    if (!result?.success){
                        notifyUser('error', result, 'Error')
                    }else{
                        setVerified(true)
                        notifyUser('success', 'Email verification successful!', 'Verified')
                    }
                }).catch(error => {
                toggleLoading()
                notifyUser('error', error, 'Error')
            })
        }
        
        verifyEmailCode()
    },[email, code]) // Added email and code dependencies

    const reTriggerEmail = () => {
        toggleLoading()
        
        // Get employerNumber from storage if available
        const employerNumber = secureLocalStorage.getItem('employerNumber')
        
        const payload = { email: secureLocalStorage.getItem('email') }
        // Include employerNumber in body if available
        if (employerNumber) {
            payload.employerNumber = employerNumber
        }
        
        serverRequest('POST', 'auth/email-verification/code/send', payload)
            .then(result => {
                toggleLoading()
                if (result?.success){
                    notifyUser('success', 'Email triggered successfully!',  'Email Verification')
                }else{
                    notifyUser('error', result?.message, 'Error')
                }
            }).catch(error => {
            toggleLoading()
            notifyUser('error', error, 'Error')
        })
    }

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <Spin spinning={loading}>
                <div>
                    {verified ?
                        <div align='center'>
                            <p className='lead fw-bold'>Email verification successful!</p>
                            <p>Your email address provided has been verified successfully.</p>
                            <img src={SuccessImg} alt='success onboard' className='img-fluid mb-5'/>
                            <div><button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={() => navigate('/onboard/create-password', {state: {email}})}>Continue</button></div>
                        </div>
                        :
                        <div align='center'>
                            <p className='lead fw-bold text-danger'>Email verification failed!</p>
                            <p>We were not able to verify the email address provided.</p>
                            <i className='bi bi-exclamation-circle-fill mb-5 text-danger' style={{fontSize: '6rem'}}/>
                            <div><button className="btn btn-primary mb-4 w-50 mobile-full-width mt-5" onClick={reTriggerEmail}>Resend Email</button></div>
                            <p className="text-center mt-3">
                                <a href="/onboard/login" className="fw-bold text-decoration-underline" style={{ color: '#009677' }}>
                                    Back to Login
                                </a>
                            </p>
                        </div>
                    }

                </div>
            </Spin>
        </div>
    )
}
